import createLucideIcon from '../createLucideIcon';

const ArrowDownLeft = createLucideIcon('ArrowDownLeftIcon', [
  ['line', { x1: '17', y1: '7', x2: '7', y2: '17', key: '1cuvd1' }],
  ['polyline', { points: '17 17 7 17 7 7', key: 'aq42rd' }],
]);

export default ArrowDownLeft;
